import { render, staticRenderFns } from "./SettingsDomains.vue?vue&type=template&id=5173a7d8&scoped=true"
import script from "./SettingsDomains.vue?vue&type=script&lang=js"
export * from "./SettingsDomains.vue?vue&type=script&lang=js"
import style0 from "./SettingsDomains.vue?vue&type=style&index=0&id=5173a7d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5173a7d8",
  null
  
)

export default component.exports